<template>
    <div>

        <h4>Acessos dos clientes tela</h4>
        <div class="dashboard-chart">

            <vue3-chart-js v-if="loaded" :id="id" ref="chartRef" :type="type" :data="data" :options="options"
                :height="height ? height : 'auto'">
            </vue3-chart-js>
            <div v-else>
                <div class="card-body text-center">
                    <span class="fa fa-spinner fa-spin fa-5x"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";

export default {
    data() {
        return {
            delayed:false,
            loaded: false,
            id: "chart",
            type: 'bar',
            height: 300,
            data: {
                labels: [],
                datasets: []
            },
            options: {
                animation: {
                    onComplete: () => {
                        this.delayed = true;
                    },
                    delay: (context) => {
                        let delay = 0;
                        if (context.type === 'data' && context.mode === 'default' && !this.delayed) {
                            delay = context.dataIndex * 200 + context.datasetIndex * 100;
                        }
                        return delay;
                    },
                },
                beginAtZero: true,
                maintainAspectRatio: false,
                interaction: {
                    mode: 'point'
                },
                plugins: {

                    legend: {
                        display: true,
                    },
                    // tooltip: {
                    //     margin: 10,
                    //     padding: 10,
                    //     position: 'average',
                    //     intersect: true,
                    //     callbacks: {
                    //         label: function (context) {
                    //             return (
                    //                 console.log(context)
                    //                 // context.dataset.label + ": " + context.value
                    //             );
                    //         },
                    //     },
                    // },

                },
                responsive: true,
                scales: {
                    // x: {

                    //     stacked: true,
                    // },
                    y: {

                        stacked: false,
                        ticks: {
                            max: 1,
                            min: 0,
                        },
                    }
                }
            }
        };
    },
    props: [],
    mounted() {
        this.getData()
    },
    methods: {

        getData() {

            let self = this
            let api = self.$store.getters.api + "analytic-log/screen-access-by-month";
            axios
                .get(api)
                .then((response) => {
                    self.data.labels = response.data.labels;
                    self.data.datasets = response.data.datasets;
                    self.loaded = true
                })
        }
    },
    components: {
        Vue3ChartJs,
    },
};
</script>